import { render, staticRenderFns } from "./upload-transmittal-report-modal.vue?vue&type=template&id=e96d71cc"
import script from "./upload-transmittal-report-modal.vue?vue&type=script&lang=js"
export * from "./upload-transmittal-report-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports